export const ENVIRONMENT_OPTIONS = ["Test", "Production"];

export const RESQUEST_TYPE_WITH_ALL_OPTIONS = [
    {
        id: "select-all-req",
        label: "All",
        isSelectAll: true
    },
    { id: "autonomous", label: "Autonomous layer Access" },
    { id: "ibp", label: "IBP Access" }
    
]

export const REQUEST_TYPE_OPTIONS = [
    { id: "autonomous", label: "Autonomous layer Access" },
    { id: "ibp", label: "IBP Access" }
]

export const AD_ROLE_OPTIONS = [
    "Bottler",
    "CSR",
    "DemandPlanner",
    "Profit center Maintainer",
    "IT",
    "Super User",
    "Admin",
  ];
 export const AD_PROCESS_TYPE_OPTIONS = ["CREATE", "DELETE"];